const offerCreationWizard = () =>
  import("./_components/CreateOffer/components/OfferCreationWizard.vue")

export default {
  path: "/offers",
  component: () => import("./index.vue"),
  children: [
    {
      path: "",
      component: () => import("./OffersList.vue"),
      name: "offers",
      meta: {
        title: "offers.title"
      }
    },
    {
      path: "create",
      component: () => import("./_components/CreateOffer/index.vue"),
      children: [
        {
          path: "",
          component: () => import("./_components/CreateOffer/components/ProductSelection.vue"),
          name: "offersCreation",
          beforeEnter: (to, _from, next) => {
            const { oid, p_code, ...query } = to.query

            if (oid) {
              return next({ name: "offerDraftEditing", params: { oid }, query, replace: true })
            }

            if (p_code) {
              return next({ name: "offerCreation", params: { p_code }, replace: true })
            }

            next()
          },
          meta: {
            title: "offers.creation.page_title",
            returnButtonName: "offers"
          }
        },
        {
          path: "drafts/:oid",
          component: offerCreationWizard,
          name: "offerDraftEditing",
          props: (route) => ({ initialProductName: route.params.initialProductName || "" }),
          meta: {
            title: "offers.product_creating",
            returnButtonName: "offersCreation"
          }
        },
        {
          path: "products/:p_code/offer",
          component: offerCreationWizard,
          name: "offerCreation",
          meta: {
            title: "offers.product_creating",
            returnButtonName: "offersCreation"
          }
        }
      ]
    }
  ]
}
